import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

import { isMobile } from '@/util/util'

/**
 * This store is used to manage the visibility of the navigation elements.
 */
export const useNavigationVisibilityStore = defineStore(
  'NavigationVisibilityStore',
  () => {
    /**
     * The visibility of the client apps menu - MenuClientApps component
     */
    const clientAppsMenuVisibility = ref(!isMobile())

    /**
     * The visibility of the app menu - PushSideBar component
     */
    const appMenuVisibility = ref(!isMobile())

    const navigationToHide = computed(
      () => appMenuVisibility.value || clientAppsMenuVisibility.value
    )

    const setAppMenuVisible = () => (appMenuVisibility.value = true)

    const setAppMenuNotVisible = () => (appMenuVisibility.value = false)

    const openSidebars = () => {
      clientAppsMenuVisibility.value = true
      appMenuVisibility.value = true
    }

    const hideSidebars = () => {
      clientAppsMenuVisibility.value = false
      appMenuVisibility.value = false
    }

    return {
      clientAppsMenuVisibility,
      appMenuVisibility,
      navigationToHide,
      setAppMenuVisible,
      setAppMenuNotVisible,
      openSidebars,
      hideSidebars,
    }
  }
)
